import { RIPPLING } from '@/integrations/modules/rippling/consts';
import type { RipplingUsersData } from '@/integrations/modules/rippling/types';
import Integrations from '@/shared/api/integrations';
import type { WiwDispatch, WiwGetState } from '@/store';

import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchRipplingUsers = createAsyncThunk('rippling/fetchUsers', async (_, { rejectWithValue }) => {
  try {
    const response = await Integrations.get(`/${RIPPLING}/v2/config/users`);
    return response as { data: RipplingUsersData };
  } catch (error) {
    return rejectWithValue(error);
  }
});

export function fetchRipplingUsersIfNeeded() {
  return (dispatch: WiwDispatch, getState: WiwGetState) => {
    if (!getState().integrations.rippling.usersConfigLoaded) {
      return dispatch(fetchRipplingUsers()).unwrap();
    }

    return Promise.resolve();
  };
}
